/* GLHK Life Stories Slider v3 — optional no-scroll fullscreen render; no autoplay. */
(function (document, window) {
  'use strict';
  var GLOBAL = '__glhkLifeStoriesSliderV3';
  if (window[GLOBAL]) {
    window[GLOBAL].refresh();
    return;
  }
  var instances = new WeakMap();
  var observed = false;

  function mount(root) {
    if (!root || instances.has(root)) return;
    var fullscreen = root.getAttribute('data-gls-viewport') === 'true';
    var opener = fullscreen ? document.querySelector('[data-gls-open][aria-controls="glhk-life-stories-stage"]') : null;
    var closeButton = fullscreen ? root.querySelector('[data-gls-close]') : null;
    var lastTrigger = null;
    var track = root.querySelector('[data-gls-track]');
    var storySlides = Array.prototype.slice.call(root.querySelectorAll('[data-gls-slide]'));
    var slides = storySlides;
    var mobileSlides = [];
    var handset = fullscreen && window.matchMedia && window.matchMedia('(max-width:760px)');
    var prev = root.querySelector('[data-gls-prev]');
    var next = root.querySelector('[data-gls-next]');
    var counter = root.querySelector('[data-gls-counter]');
    var bar = root.querySelector('[data-gls-bar]');
    if (!track || !slides.length || !prev || !next || !counter) return;
    if (fullscreen && (!opener || !closeButton)) return;

    var index = 0;
    var raf = 0;
    // One source of truth: consume the existing twelve Hotspot panels and
    // their approved URLs. Never duplicate scenario text or tool routes here.
    function prepareMobileQuestions() {
      if (!handset || mobileSlides.length) return;
      var hotspots = Array.prototype.slice.call(document.querySelectorAll('[data-glhk-home-hotspots] [data-hotspot]'));
      if (hotspots.length !== 12) return;
      var categoryArt = {
        home:0, build:2, life:0, business:2
      };
      var artTemplates = storySlides.map(function (slide) {return slide.querySelector('.glhk-life-stories__art');});
      var made = [];
      hotspots.forEach(function (hotspot, i) {
        var panel = hotspot.querySelector('[data-hotspot-panel]');
        if (!panel) return;
        var heading = panel.querySelector('.glhk-home-hotspot__question');
        var note = panel.querySelector('.glhk-home-hotspot__note');
        var links = Array.prototype.slice.call(panel.querySelectorAll('a.glhk-home-hotspot__link[href]'));
        var kind = (hotspot.className.match(/glhk-home-hotspot--(home|build|life|business)/) || [])[1] || 'home';
        if (!heading || !note || !links.length || !artTemplates[categoryArt[kind]]) return;
        var slide = document.createElement('article');
        slide.className = 'glhk-life-stories__slide';
        slide.setAttribute('data-gls-slide','');
        slide.setAttribute('data-gls-mobile-question','');
        slide.setAttribute('role','group');
        slide.setAttribute('aria-roledescription','slide');
        slide.setAttribute('aria-label',String(i+1)+' / 12');
        var card = document.createElement('div');
        card.className = 'glhk-life-stories__card';
        card.style.setProperty('--gls-tone',kind==='business'?'#e9e4dc':kind==='build'?'#e4ece8':'#dceae3');
        var art = artTemplates[categoryArt[kind]].cloneNode(true);
        var body = document.createElement('div');
        body.className = 'glhk-life-stories__body';
        var title = document.createElement('h3');
        title.className = 'glhk-life-stories__story-title';
        title.textContent = heading.textContent.trim();
        var copy = document.createElement('p');
        copy.className = 'glhk-life-stories__story-copy';
        copy.textContent = note.textContent.trim();
        var actions = document.createElement('div');
        actions.className = 'glhk-life-stories__actions';
        links.forEach(function (link, k) {
          var anchor = document.createElement('a');
          anchor.className = 'glhk-life-stories__cta'+(k?' glhk-life-stories__cta--secondary':'');
          anchor.href = link.getAttribute('href');
          anchor.textContent = link.textContent.replace(/↗/g,'').trim();
          actions.appendChild(anchor);
        });
        body.append(title,copy,actions);
        card.append(art,body);
        slide.appendChild(card);
        slide.hidden = true;
        made.push(slide);
      });
      if (made.length !== 12) return;
      made.forEach(function (slide) {track.appendChild(slide);});
      mobileSlides = made;
    }
    function syncMobileMode() {
      if (!fullscreen) return;
      if (handset && handset.matches) prepareMobileQuestions();
      var useMobile = Boolean(handset && handset.matches && mobileSlides.length === 12);
      slides = useMobile ? mobileSlides : storySlides;
      storySlides.forEach(function (slide) {slide.hidden = useMobile;});
      mobileSlides.forEach(function (slide) {slide.hidden = !useMobile;});
      root.setAttribute('data-gls-question-mode',useMobile?'12':'3');
      if (index >= slides.length) index = 0;
    }
    function targetLeft(i) {
      // Use the same offset parent for all cards; this works for multiple snippet instances.
      return slides[i].offsetLeft - slides[0].offsetLeft;
    }
    function update(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      if (bar) {
        bar.style.width = (100 / slides.length) + '%';
        bar.style.transform = 'translateX(' + (index * 100) + '%)';
      }
      // One full card visible at a time; progress advances in single-slot units.
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      slides.forEach(function (slide, k) {
        slide.setAttribute('aria-current', k === index ? 'true' : 'false');
        if (fullscreen) slide.hidden = k !== index;
      });
    }
    function go(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var left = targetLeft(i);
      if (!fullscreen) {
        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: left, behavior: reduced || instant ? 'auto' : 'smooth' });
        } else {
          track.scrollLeft = left;
        }
      }
      update(i);
    }
    prev.addEventListener('click', function () { go(index - 1); });
    next.addEventListener('click', function () { go(index + 1); });
    track.addEventListener('keydown', function (event) {
      if (event.target && event.target.closest && event.target.closest('a, button, input, textarea, select')) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); go(index + 1); }
      if (event.key === 'Home') { event.preventDefault(); go(0); }
      if (event.key === 'End') { event.preventDefault(); go(slides.length - 1); }
    });
    if (fullscreen) {
      // Fullscreen uses hidden slides rather than native scrolling.
      // Swipe left/right on touch devices, without blocking vertical page gestures.
      var touchStart = null;
      track.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) { touchStart = null; return; }
        touchStart = {x:event.touches[0].clientX, y:event.touches[0].clientY};
      }, {passive:true});
      track.addEventListener('touchend', function (event) {
        if (!touchStart || !event.changedTouches.length || root.hidden) { touchStart = null; return; }
        var dx = event.changedTouches[0].clientX - touchStart.x;
        var dy = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.35) {
          go(index + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      track.addEventListener('touchcancel', function () { touchStart = null; }, {passive:true});
      function openStage(event) {
        lastTrigger = event && event.target && typeof event.target.focus === 'function' ? event.target : document.activeElement;
        syncMobileMode();
        go(0, true);
        root.hidden = false;
        root.dataset.glsActive = 'true';
        // Pointer clicks focus the dialog without an intrusive visible focus halo.
        // Keyboard activation intentionally focuses Close to retain focus visibility.
        var keyboardActivation = Boolean(event && event.detail === 0);
        (keyboardActivation ? closeButton : root).focus({ preventScroll: true });
      }
      function closeStage() {
        root.hidden = true;
        delete root.dataset.glsActive;
        var target = lastTrigger && lastTrigger.isConnected ? lastTrigger : opener;
        if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
      }
      // The existing Find My Opportunities anchor opens Stories when JS is ready.
      // Its original href remains a usable fallback if JS fails or is disabled.
      opener.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        openStage(event);
      });
      closeButton.addEventListener('click', closeStage);
      // On handsets, both homepage entry points open the same 12-question
      // story surface. Cancel the legacy two-column drawer before its handler.
      document.addEventListener('click',function (event) {
        if (!handset || !handset.matches || !event.target || !event.target.closest) return;
        var hotspotEntry = event.target.closest('[data-hotspot-open]');
        if (!hotspotEntry || !mobileSlides.length) {
          if (hotspotEntry) prepareMobileQuestions();
          if (!hotspotEntry || mobileSlides.length !== 12) return;
        }
        event.preventDefault();
        event.stopPropagation();
        openStage(event);
      },true);
      if (handset && typeof handset.addEventListener === 'function') {
        handset.addEventListener('change',function () {syncMobileMode();go(0,true);});
      }
      root.addEventListener('keydown', function (event) {
        if (root.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeStage();
          return;
        }
        if (event.key !== 'Tab') return;
        var activeSlide = slides[index];
        var candidates = Array.prototype.slice.call(root.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'));
        var visible = candidates.filter(function (node) {
          return !node.closest('[hidden]') && !node.disabled;
        });
        if (!visible.length) { event.preventDefault(); root.focus(); return; }
        var first = visible[0];
        var last = visible[visible.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
    }
    // Scroll events cover native touch swipes outside the fullscreen homepage mode.
    track.addEventListener('scroll', function () {
      if (fullscreen) return;
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        var closest = 0;
        var distance = Infinity;
        slides.forEach(function (slide, k) {
          var d = Math.abs(targetLeft(k) - track.scrollLeft);
          if (d < distance) { distance = d; closest = k; }
        });
        update(closest);
      });
    }, { passive: true });
    // Preserve the selected card on responsive width changes.
    if (typeof window.ResizeObserver === 'function') {
      var resize = new window.ResizeObserver(function () { go(index, true); });
      resize.observe(track);
    }
    syncMobileMode();
    instances.set(root, {go:go});
    update(0);
  }
  function refresh(container) {
    var context = container && container.querySelectorAll ? container : document;
    if (context.matches && context.matches('[data-glhk-life-stories]')) mount(context);
    context.querySelectorAll('[data-glhk-life-stories]').forEach(mount);
  }
  window[GLOBAL] = {refresh: refresh};
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(document); });
  } else {
    refresh(document);
  }
  // Shopify Theme Editor replaces Custom Liquid sections without a full page load.
  document.addEventListener('shopify:section:load', function (event) { refresh(event.target); });
  document.addEventListener('shopify:section:reorder', function () { refresh(document); });
  // Some Custom Liquid / app surfaces inject the snippet after DOMContentLoaded.
  if (!observed && typeof window.MutationObserver === 'function' && document.documentElement) {
    observed = true;
    var scheduled = false;
    new window.MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () { scheduled = false; refresh(document); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})(document, window);
